function countActiveFilters(selectedFilters) {
  const fileTypesActiveFiltersCount = countArrayItems('fileTypes')
  const modelTypeActiveFiltersCount = countObjectItems('modelType')
  const polygonsActiveFiltersCount = countArrayItems('polygonRange')
  const licensesActiveFiltersCount = countArrayItems('licenses')
  const pricingActiveFiltersCount = countObjectItems('pricing')
  const priceRangeActiveFiltersCount = countArrayItems('priceRange')
  const metaverseActiveFiltersCount = countArrayItems('compatible')
  const miscellaneousActiveFiltersCount = countArrayItems('miscellaneous')
  const designersActiveFiltersCount = countObjectItems('designers')

  function countArrayItems(key) {
    return selectedFilters[key] ? selectedFilters[key].length : 0
  }

  function countObjectItems(key) {
    return selectedFilters[key] ? Object.keys(selectedFilters[key]).filter(
      (item) => selectedFilters[key][item] === '1'
    ).length : 0
  }

  return {
    fileTypesActiveFiltersCount,
    modelTypeActiveFiltersCount,
    polygonsActiveFiltersCount,
    licensesActiveFiltersCount,
    pricingActiveFiltersCount,
    metaverseActiveFiltersCount,
    priceRangeActiveFiltersCount,
    miscellaneousActiveFiltersCount,
    designersActiveFiltersCount
  }
}

export default countActiveFilters
